/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: yk0RhbxcMVQJ

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { RawTd } from "@myevaluations/myevals-plasmic-utils/dist/code-components/RawTable/Td"; // plasmic-import: FrIKVRIybXcj/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTableTd.module.css"; // plasmic-import: yk0RhbxcMVQJ/css

createPlasmicElementProxy;

export type PlasmicTableTd__VariantMembers = {};
export type PlasmicTableTd__VariantsArgs = {};
type VariantPropType = keyof PlasmicTableTd__VariantsArgs;
export const PlasmicTableTd__VariantProps = new Array<VariantPropType>();

export type PlasmicTableTd__ArgsType = {
  children?: React.ReactNode;
  rowSpan?: number;
  colSpan?: number;
  alternateBackground?: boolean;
  verticalAlign?: string;
  background?: string;
};
type ArgPropType = keyof PlasmicTableTd__ArgsType;
export const PlasmicTableTd__ArgProps = new Array<ArgPropType>(
  "children",
  "rowSpan",
  "colSpan",
  "alternateBackground",
  "verticalAlign",
  "background"
);

export type PlasmicTableTd__OverridesType = {
  root?: Flex__<typeof RawTd>;
};

export interface DefaultTableTdProps {
  children?: React.ReactNode;
  rowSpan?: number;
  colSpan?: number;
  alternateBackground?: boolean;
  verticalAlign?: string;
  background?: string;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTableTd__RenderFunc(props: {
  variants: PlasmicTableTd__VariantsArgs;
  args: PlasmicTableTd__ArgsType;
  overrides: PlasmicTableTd__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          colSpan: 1,
          alternateBackground: false,
          verticalAlign: "middle"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <RawTd
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      colSpan={args.colSpan}
      rowSpan={args.rowSpan}
      style={(() => {
        try {
          return {
            background: $props.alternateBackground
              ? "#FAFBFC"
              : $props.background,
            verticalAlign: $props.verticalAlign
          };
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <div className={classNames("all", "__wab_text", sty.text___5NnZu)}>
            {"Cell"}
          </div>
        ),
        value: args.children
      })}
    </RawTd>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof RawTd;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTableTd__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTableTd__VariantsArgs;
    args?: PlasmicTableTd__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTableTd__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTableTd__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTableTd__ArgProps,
          internalVariantPropNames: PlasmicTableTd__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTableTd__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTableTd";
  } else {
    func.displayName = `PlasmicTableTd.${nodeName}`;
  }
  return func;
}

export const PlasmicTableTd = Object.assign(
  // Top-level PlasmicTableTd renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicTableTd
    internalVariantProps: PlasmicTableTd__VariantProps,
    internalArgProps: PlasmicTableTd__ArgProps
  }
);

export default PlasmicTableTd;
/* prettier-ignore-end */
